/*
 * Keeps the cart UI honest on pages that did NOT come fresh from the server.
 *
 * The buy widgets add to cart and then send the shopper straight to /checkout.
 * Pressing Back serves the previous page from the browser's back/forward cache,
 * so its markup still shows the cart from BEFORE the add — stale drawer, stale
 * header count — until the shopper thinks to reload.
 *
 * On those loads (and when a backgrounded tab is brought forward, where the cart
 * may have changed in another tab) this compares the cart the markup was rendered
 * from — `[data-cart-token]`, written by snippets/cart-drawer.liquid — against
 * /cart.js, and republishes cartUpdate only when they actually differ. That one
 * event is enough: the drawer, the header badge and skio-cart-plan-sync all
 * subscribe to it.
 *
 * A fresh navigation is deliberately NOT verified — the server just rendered the
 * live cart, so checking would add a request to every single page view.
 */
(() => {
  if (window.__mlCartRefreshLoaded) return;
  window.__mlCartRefreshLoaded = true;

  function renderedToken() {
    const holder = document.querySelector('[data-cart-token]');
    return holder ? holder.getAttribute('data-cart-token') : null;
  }

  // Must match the {% capture cart_token %} in snippets/cart-drawer.liquid
  function serverToken(cart) {
    const lines = (cart.items || []).map((item) => `${item.key}x${item.quantity},`).join('');
    return `${cart.item_count}:${cart.total_price}:${lines}`;
  }

  let checking = false;

  function reconcile() {
    if (checking) return;
    const token = renderedToken();
    if (token === null) return;
    checking = true;

    fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then((response) => response.json())
      .then((cart) => {
        if (serverToken(cart) === token) return;
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ml-cart-refresh', cartData: cart });
        }
      })
      .catch((e) => console.error('Cart refresh: failed', e))
      .finally(() => {
        checking = false;
      });
  }

  window.addEventListener('pageshow', (event) => {
    const nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    // event.persisted = back/forward cache; nav.type = a Back that missed the bfcache
    if (event.persisted || (nav && nav.type === 'back_forward')) reconcile();
  });

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') reconcile();
  });
})();
